import type { ReactElement } from 'react';
import { InlineLinkButton } from './Button';
import { formatDate } from './format';
import s from './History.module.css';

export interface LastChange {
  /** Who made the change ("Sam Ortega"). */
  by: string;
  /** When: `YYYY-MM-DD` or an ISO timestamp. */
  on: string;
  /** Whose behalf it was made on, if not their own ("Graham Whitlock"). */
  forWhom?: string;
}

export interface HistoryLineProps {
  /** The latest change, or `null` when the value is still the one from setup. */
  lastChange: LastChange | null;
  /** Opens the History drawer for this value. */
  onOpenHistory: () => void;
  /** Wording when nothing has changed yet. */
  unchangedText?: string;
}

/** "Last changed by Sam Ortega for Graham Whitlock on Oct 2, 2026 · History", under a setting value. */
export function HistoryLine({
  lastChange,
  onOpenHistory,
  unchangedText = 'Not changed since setup',
}: HistoryLineProps): ReactElement {
  return (
    <span className={s.line}>
      {lastChange === null ? (
        unchangedText
      ) : (
        <>
          Last changed by {lastChange.by}
          {lastChange.forWhom !== undefined && ` for ${lastChange.forWhom}`} on{' '}
          {formatDate(lastChange.on)}
        </>
      )}
      {' · '}
      <InlineLinkButton onPress={onOpenHistory}>History</InlineLinkButton>
    </span>
  );
}
